import React from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { fromZonedTime } from 'date-fns-tz';

const TimezoneDisplay = ({ date, time, timezone }) => {
  if (!date || !time) return null;

  try {
    // Create the date-time string in the selected timezone
    const dateTimeString = `${date}T${time}:00`;
    
    // Convert to UTC for storage
    const utcDate = fromZonedTime(dateTimeString, timezone);
    
    // Get user's detected timezone
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    return (
      <div className="mt-3 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
        <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">
          📅 Timezone Information
        </h4>
        <div className="space-y-1 text-xs text-blue-800 dark:text-blue-200">
          <div>
            <span className="font-medium">Selected:</span> {formatInTimeZone(utcDate, timezone, 'EEEE, MMMM d, yyyy h:mm a zzz')}
          </div>
          <div>
            <span className="font-medium">UTC Storage:</span> {formatInTimeZone(utcDate, 'UTC', 'EEEE, MMMM d, yyyy HH:mm zzz')}
          </div>
          <div>
            <span className="font-medium">Your Time:</span> {formatInTimeZone(utcDate, userTimezone, 'EEEE, MMMM d, yyyy h:mm a zzz')}
          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error('Error in TimezoneDisplay:', error);
    return null;
  }
};

export default TimezoneDisplay;


